function formatPrice(price) {  
  price = parseFloat(price).toFixed(2);
  return "$"+(new Intl.NumberFormat('es-AR', {})).format(price)
}

function formatPriceNumber(price) {  
  return parseFloat(parseFloat(price).toFixed(2));  
}

function formatDateString(date_string) {
  //Format "yyyy-mm-dd" to "dd/mm/yyyy" (de esta forma no hay problema con UTC)
  const [year, month, day] = date_string.split('-');
  return `${day}/${month}/${year}`;
}

function formatDate(dateString) {
  //Format dd/mm/yyyy to yyyy-mm-dd
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Asegura 2 dígitos
  const day = String(date.getDate()).padStart(2, '0'); // Asegura 2 dígitos
  return `${year}-${month}-${day}`;
}

function hasValue(v) {
  return v !== null && v !== undefined && v !== "";
}

function formatSeconds(seg) {
  if (!hasValue(seg)) return "-";
  const n = Math.round(Number(seg));
  if (isNaN(n) || n < 0) return "-";
  if (n < 60) return n + "s";
  if (n < 3600) {
    const m = Math.floor(n / 60);
    const s = Math.round(n % 60);
    return s ? m + "m " + s + "s" : m + "m";
  }
  if (n < 86400) {
    const h = Math.floor(n / 3600);
    const m = Math.floor((n % 3600) / 60);
    return m ? h + "h " + m + "m" : h + "h";
  }
  const d = Math.floor(n / 86400);
  const h = Math.floor((n % 86400) / 3600);
  return h ? d + "d " + h + "h" : d + "d";
}

function formatHora(datetime, fechaRef = null) {
  if (!datetime) return "-";
  const [fecha, hora] = datetime.split(" ");
  const hhmm = (hora || "").substring(0, 5);
  const diff = Math.round((new Date(fecha + "T00:00:00") - new Date(fechaRef + "T00:00:00")) / 86400000);
  if (!diff || isNaN(diff)) return hhmm;
  return hhmm + " " + (diff > 0 ? "+" : "") + diff + "d";
}

export const formatUtils = {
  formatPrice,
  formatPriceNumber,
  formatDateString,
  formatDate,
  formatSeconds,
  formatHora
};
